module.exports = __webpack_public_path__ + "static/media/icon_notif.57472bd3.png";